/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';

import { ErrorElementPictures } from '../../../../../api/errorReport/types';
import {
  IconArrowBackMS,
  IconArrowForwardIosMS,
  IconCloseMS,
} from '../../../../../constants/icons';
import {
  ArrowButton,
  CloseButton,
  ContainerModal,
  MainBox,
  MainCardMedia,
  MoreImages,
  PicturesContainer,
  ScrollContainer,
  StyledBox,
  ThumbCardMedia,
} from './styles';

interface AllPicturesSliderProps {
  images: ErrorElementPictures[];
}

export default function AllPicturesSlider({
  images,
}: AllPicturesSliderProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const { length } = images;

  const nextImage = (): void => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevImage = (): void => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  return (
    <>
      <MoreImages onClick={handleOpen}>Mais imagens</MoreImages>
      <ContainerModal
        open={open}
        onClose={handleClose}
        aria-labelledby="picture dialog"
      >
        <StyledBox>
          <MainBox>
            <CloseButton onClick={handleClose}>{IconCloseMS}</CloseButton>
            <ArrowButton disableTouchRipple onClick={prevImage}>
              {IconArrowBackMS}
            </ArrowButton>
            {images.map(
              (slide, index) =>
                index === current && (
                  <MainCardMedia
                    key={slide.url}
                    image={slide.url}
                    title={slide.caption}
                    component="img"
                  />
                )
            )}
            <ArrowButton disableTouchRipple onClick={nextImage}>
              {IconArrowForwardIosMS}
            </ArrowButton>
          </MainBox>
          <PicturesContainer>
            <ScrollContainer>
              {images.map((slide, index) => (
                <ThumbCardMedia
                  key={slide.url}
                  image={slide.url}
                  component="img"
                  onClick={() => setCurrent(index)}
                />
              ))}
            </ScrollContainer>
          </PicturesContainer>
        </StyledBox>
      </ContainerModal>
    </>
  );
}
